module.exports = __webpack_public_path__ + "assets/img/companyLogo_01.64640c6c.jpg";